module.exports = __webpack_public_path__ + "static/img/banner.fe0d055a.png";